import { render, staticRenderFns } from "./OngoingProcessSteps.vue?vue&type=template&id=726d2e34&"
import script from "./OngoingProcessSteps.vue?vue&type=script&lang=js&"
export * from "./OngoingProcessSteps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports